import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { roleIsElevated } from "@/lib/roles";
import { AuthLoading } from "@/components/auth/AuthLoading";

/**
 * Route guard that gates admin-bucket pages (/team, /activity, settings
 * admin sections). Passes for admin_user OR route_manager — both have
 * team-level powers per migration 0019. The handful of admin_user-only
 * actions (lead delete, lead export, role change) are gated separately
 * at the action level via useIsFullAdmin().
 */
export function AdminRoute() {
  const status = useAuthStore((s) => s.status);
  const elevated = useAuthStore((s) => roleIsElevated(s.user?.role));
  if (status === "loading") return <AuthLoading />;
  if (!elevated) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
